import { HttpClient } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { isSSRMode } from '@constants/app.constant';
import { BaseResponse } from '@models/common.model';
import { AirCraftDDL, FareRuleMapKeyReq, FareRuleMapKeyRes } from '@models/master-data.model';
import { InFlightServiceMap } from '@models/store.model';
import { HttpService } from '@services/http.service';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class MasterDataService {
    constructor(
        private readonly _http: HttpService,
        private readonly _httpClient: HttpClient
    ) {}

    /**
     * Get list fare rule map key
     *
     * @param {FareRuleMapKeyReq[]} req
     * @return {*}  {Observable<FareRuleMapKeyMasterData[]>}
     * @memberof MasterDataService
     */
    public getListFareRuleMapKey(req: FareRuleMapKeyReq[]): Observable<FareRuleMapKeyRes[]> {
        return this._http
            .post<BaseResponse<FareRuleMapKeyRes[]>>('MasterData/SearchListFareRuleMapKey', req)
            .pipe(
                catchError(() => of(new BaseResponse<FareRuleMapKeyRes[]>({ Data: [] }))),
                map((res) => res.Data || [])
            );
    }

    /**
     * Get list air crafts
     *
     * @return {*}  {Observable<AirCraftDDL[]>}
     * @memberof MasterDataService
     */
    public getAirCrafts(): Observable<AirCraftDDL[]> {
        return this._http.get<BaseResponse<AirCraftDDL[]>>('MasterData/GetAirCraft').pipe(
            catchError(() => of(new BaseResponse<AirCraftDDL[]>({ Data: [] }))),
            map((res) => res.Data || [])
        );
    }

    /**
     * Get in flight service maps
     *
     * @return {*}  {Observable<InFlightServiceMap>}
     * @memberof MasterDataService
     */
    public getInFlightServiceMaps(): Observable<InFlightServiceMap[]> {
        const url = !isSSRMode
            ? `/assets/data/in-flight-service.json`
            : '/api/master-data/in-flight-services';
        return this._httpClient.get<InFlightServiceMap[]>(url);
    }
}
